module.exports = __webpack_public_path__ + "static/media/plus.21ecf72b.svg";